/*
  This component will take two Inputs:
    1. match: A mandatory input and number ranging from 0 - 100
    2. matchConfig: An optional input color configuration object like following
    { 
      thresholdVal:  50,
      colorCode:  [
        {color:"rgba(183, 28, 28, 1)", min: 0, max: 29},
        {color:"rgba(247, 148, 30, 1)", min: 30, max: 59} , 
        {color:"rgba(130, 196, 60, 1)", min: 60, max: 100} ],
    }
*/
import { Component, OnChanges, Input } from '@angular/core';

@Component({
  selector: 'app-semicircular-progressbar',
  templateUrl: './semicircular-progressbar.component.html',
  styleUrls: ['./semicircular-progressbar.component.scss'],
  standalone: false,
})
export class SemicircularProgressbarComponent implements OnChanges {
  @Input() match: number = 0;
  @Input() percentage: boolean = false;
  @Input() matchConfig: any = {
    thresholdVal: 50,
    colorCode: [
      { color: 'rgba(183, 28, 28, 1)', min: 0, max: 29 },
      { color: 'rgba(247, 148, 30, 1)', min: 30, max: 59 },
      { color: 'rgba(130, 196, 60, 1)', min: 60, max: 100 },
    ],
  };
  matchText: string = 'NO MATCH';
  colorVal = '';
  rotationVal = 'rotate(0deg)';

  constructor() {}
  ngOnChanges() {
    this.match = Math.ceil(this.match);
    let matchCount = 45;
    matchCount += this.match * 1.8;
    this.rotationVal = 'rotate(' + matchCount + 'deg)';
    this.matchConfig.colorCode.forEach((val) => {
      if (this.match >= val.min && this.match <= val.max) {
        this.colorVal = val.color;
      }
    });
    if (this.match < this.matchConfig.thresholdVal) {
      this.matchText = 'NO MATCH';
    } else {
      this.matchText = 'MATCH';
    }
    if (this.percentage) {
      this.matchText = '% Completed';
    }
  }
}
